import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader } from "../../../components";
import {
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Snackbar,
  Alert,
  Paper,
  Autocomplete,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Col, Row, Form } from "react-bootstrap";

const UbahRegister = () => {
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [kodeRegister, setKodeRegister] = useState("");
  const [namaRegister, setNamaRegister] = useState("");
  const [almRegister, setAlmRegister] = useState("");
  const [tlpRegister, setTlpRegister] = useState("");
  const [noKtpRegister, setNoKtpRegister] = useState("");
  const [almKtpRegister, setAlmKtpRegister] = useState("");
  const [noKKRegister, setNoKKRegister] = useState("");
  const [namaIbuKandungRegister, setNamaIbuKandungRegister] = useState("");
  const [namaPjmRegister, setNamaPjmRegister] = useState("");
  const [almPjmRegister, setAlmPjmRegister] = useState("");
  const [tlpPjmRegister, setTlpPjmRegister] = useState("");
  const [hubunganRegister, setHubunganRegister] = useState("");
  const [noKtpPjmRegister, setNoKtpPjmRegister] = useState("");
  const [namaRefRegister, setNamaRefRegister] = useState("");
  const [almRefRegister, setAlmRefRegister] = useState("");
  const [tlpRefRegister, setTlpRefRegister] = useState("");
  const [kelurahanId, setKelurahanId] = useState("");
  const [pekerjaanId, setPekerjaanId] = useState("");
  const [pekerjaanPenjaminId, setPekerjaanPenjaminId] = useState("");

  const [kelurahans, setKelurahans] = useState([]);
  const [pekerjaans, setPekerjaans] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const [validated, setValidated] = useState(false);
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const kelurahanOptions = kelurahans.map((kelurahan) => ({
    label: `${kelurahan.kodeKelurahan} - ${kelurahan.namaKelurahan}`,
  }));

  const pekerjaanOptions = pekerjaans.map((pekerjaan) => ({
    label: `${pekerjaan.kodePekerjaan} - ${pekerjaan.namaPekerjaan}`,
  }));

  useEffect(() => {
    getRegisterById();
    getKelurahan();
    getPekerjaan();
  }, []);

  const getKelurahan = async () => {
    setLoading(true);
    const allKelurahans = await axios.post(`${tempUrl}/kelurahans`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setKelurahans(allKelurahans.data);
    setLoading(false);
  };

  const getPekerjaan = async () => {
    setLoading(true);
    const allPekerjaans = await axios.post(`${tempUrl}/pekerjaans`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setPekerjaans(allPekerjaans.data);
    setLoading(false);
  };

  const getRegisterById = async () => {
    setLoading(true);
    const pickedRegister = await axios.post(`${tempUrl}/registers/${id}`, {
      id: user._id,
      token: user.token,
    });
    setKodeRegister(pickedRegister.data.noRegister);
    setNamaRegister(pickedRegister.data.namaRegister);
    setAlmRegister(pickedRegister.data.almRegister);
    setTlpRegister(pickedRegister.data.tlpRegister);
    setNoKtpRegister(pickedRegister.data.noKtpRegister);
    setAlmKtpRegister(pickedRegister.data.almKtpRegister);
    setNoKKRegister(pickedRegister.data.noKKRegister);
    setNamaIbuKandungRegister(pickedRegister.data.namaIbuKandungRegister);
    setNamaPjmRegister(pickedRegister.data.namaPjmRegister);
    setAlmPjmRegister(pickedRegister.data.almPjmRegister);
    setTlpPjmRegister(pickedRegister.data.tlpPjmRegister);
    setHubunganRegister(pickedRegister.data.hubunganRegister);
    setNoKtpPjmRegister(pickedRegister.data.noKtpPjmRegister);
    setNamaRefRegister(pickedRegister.data.namaRefRegister);
    setAlmRefRegister(pickedRegister.data.almRefRegister);
    setTlpRefRegister(pickedRegister.data.tlpRefRegister);
    setPekerjaanId(
      `${pickedRegister.data.pekerjaanId.kodePekerjaan} - ${pickedRegister.data.pekerjaanId.namaPekerjaan}`
    );
    setPekerjaanPenjaminId(
      `${pickedRegister.data.pekerjaanPenjaminId.kodePekerjaan} - ${pickedRegister.data.pekerjaanPenjaminId.namaPekerjaan}`
    );
    setKelurahanId(
      `${pickedRegister.data.kelurahanId.kodeKelurahan} - ${pickedRegister.data.kelurahanId.namaKelurahan}`
    );
    setLoading(false);
  };

  const updateRegister = async (e) => {
    e.preventDefault();
    var date = new Date();
    var current_date =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    var current_time =
      date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    let isFailedValidation =
      namaRegister.length === 0 ||
      almRegister.length === 0 ||
      tlpRegister.length === 0 ||
      noKtpRegister.length === 0 ||
      almKtpRegister.length === 0 ||
      noKKRegister.length === 0 ||
      pekerjaanId.length === 0 ||
      kelurahanId.length === 0 ||
      pekerjaanPenjaminId.length === 0;

    if (namaPjmRegister.length > 0) {
      isFailedValidation =
        namaRegister.length === 0 ||
        almRegister.length === 0 ||
        tlpRegister.length === 0 ||
        noKtpRegister.length === 0 ||
        almKtpRegister.length === 0 ||
        noKKRegister.length === 0 ||
        pekerjaanId.length === 0 ||
        kelurahanId.length === 0 ||
        namaPjmRegister.length === 0 ||
        almPjmRegister.length === 0 ||
        tlpPjmRegister.length === 0 ||
        hubunganRegister.length === 0 ||
        noKtpPjmRegister.length === 0 ||
        pekerjaanPenjaminId.length === 0;
    }

    if (isFailedValidation) {
      setError(true);
      setOpen(!open);
    } else {
      try {
        setLoading(true);
        const findKelurahan = await axios.post(`${tempUrl}/kelurahanByKode`, {
          kodeKelurahan: kelurahanId.split(" ", 1)[0],
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        });
        const findPekerjaan = await axios.post(`${tempUrl}/pekerjaanByKode`, {
          kodePekerjaan: pekerjaanId.split(" ", 1)[0],
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        });
        const findPekerjaanPenjamin = await axios.post(
          `${tempUrl}/pekerjaanByKode`,
          {
            kodePekerjaan: pekerjaanPenjaminId.split(" ", 1)[0],
            id: user._id,
            token: user.token,
            kodeCabang: user.cabang._id,
          }
        );
        await axios.post(`${tempUrl}/updateRegister/${id}`, {
          namaRegister,
          almRegister,
          tlpRegister,
          noKtpRegister,
          almKtpRegister,
          noKKRegister,
          namaIbuKandungRegister,
          namaPjmRegister,
          almPjmRegister,
          tlpPjmRegister,
          hubunganRegister,
          noKtpPjmRegister,
          namaRefRegister,
          almRefRegister,
          tlpRefRegister,
          kelurahanId: findKelurahan.data._id,
          pekerjaanId: findPekerjaan.data._id,
          pekerjaanPenjaminId: findPekerjaanPenjamin.data._id,
          tglUpdate: current_date,
          jamUpdate: current_time,
          userUpdate: user.username,
          kodeCabang: user.cabang._id,
          id: user._id,
          token: user.token,
        });
        setLoading(false);
        navigate(`/register/${id}`);
      } catch (error) {
        if (error.response.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        console.log(error);
      }
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Box>
      <Typography color="#757575">Penjualan</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Ubah Register
      </Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={updateRegister}>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kode Register :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeRegister} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama Register <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={namaRegister}
                        required
                        onChange={(e) =>
                          setNamaRegister(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Nama harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Alamat Register <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={almRegister}
                        required
                        onChange={(e) =>
                          setAlmRegister(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Alamat harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Telepon Register <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={tlpRegister}
                        type="number"
                        required
                        onChange={(e) =>
                          setTlpRegister(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Telepon harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. KTP <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={noKtpRegister}
                        required
                        onChange={(e) =>
                          setNoKtpRegister(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        No. KTP harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Alamat KTP <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={almKtpRegister}
                        required
                        onChange={(e) =>
                          setAlmKtpRegister(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Alamat KTP harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. KK <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={noKKRegister}
                        required
                        onChange={(e) =>
                          setNoKKRegister(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        No. KK harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama Ibu Kandung :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={namaIbuKandungRegister}
                        onChange={(e) =>
                          setNamaIbuKandungRegister(
                            e.target.value.toUpperCase()
                          )
                        }
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Pekerjaan <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={pekerjaanOptions}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            error={error && pekerjaanId.length === 0 && true}
                            helperText={
                              error &&
                              pekerjaanId.length === 0 &&
                              "Kode Pekerjaan harus diisi!"
                            }
                            {...params}
                          />
                        )}
                        value={{ label: pekerjaanId }}
                        onInputChange={(e, value) => setPekerjaanId(value)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kode Kelurahan <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={kelurahanOptions}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            error={error && kelurahanId.length === 0 && true}
                            helperText={
                              error &&
                              kelurahanId.length === 0 &&
                              "Kode Kelurahan harus diisi!"
                            }
                            {...params}
                          />
                        )}
                        value={{ label: kelurahanId }}
                        onInputChange={(e, value) => setKelurahanId(value)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              {namaPjmRegister.length > 0 ? (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nama Penjamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={namaPjmRegister}
                          onChange={(e) =>
                            setNamaPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nama Penjamin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={namaPjmRegister}
                          onChange={(e) =>
                            setNamaPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {namaPjmRegister.length > 0 ? (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Alamat Penjamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={almPjmRegister}
                          required
                          onChange={(e) =>
                            setAlmPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          Alamat Penjamin harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Alamat Penjamin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={almPjmRegister}
                          onChange={(e) =>
                            setAlmPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {namaPjmRegister.length > 0 ? (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Telepon Penjamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          type="number"
                          value={tlpPjmRegister}
                          required
                          onChange={(e) =>
                            setTlpPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          Telepon Penjamin harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Telepon Penjamin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          type="number"
                          value={tlpPjmRegister}
                          onChange={(e) =>
                            setTlpPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {namaPjmRegister.length > 0 ? (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Hubungan Penjamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={hubunganRegister}
                          required
                          onChange={(e) =>
                            setHubunganRegister(e.target.value.toUpperCase())
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          Hubungan Penjamin harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Hubungan Penjamin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={hubunganRegister}
                          onChange={(e) =>
                            setHubunganRegister(e.target.value.toUpperCase())
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {namaPjmRegister.length > 0 ? (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. KTP Penjamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={noKtpPjmRegister}
                          required
                          onChange={(e) =>
                            setNoKtpPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          No. KTP Penjamin harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. KTP Penjamin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={noKtpPjmRegister}
                          onChange={(e) =>
                            setNoKtpPjmRegister(e.target.value.toUpperCase())
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Pekerjaan Penjamin <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={pekerjaanOptions}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            error={
                              error && pekerjaanPenjaminId.length === 0 && true
                            }
                            helperText={
                              error &&
                              pekerjaanPenjaminId.length === 0 &&
                              "Pekerjaan Penjamin harus diisi!"
                            }
                            {...params}
                          />
                        )}
                        value={{ label: pekerjaanPenjaminId }}
                        onInputChange={(e, value) =>
                          setPekerjaanPenjaminId(value)
                        }
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama Referensi :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={namaRefRegister}
                        onChange={(e) =>
                          setNamaRefRegister(e.target.value.toUpperCase())
                        }
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Alamat Referensi :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={almRefRegister}
                        onChange={(e) =>
                          setAlmRefRegister(e.target.value.toUpperCase())
                        }
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Telepon Referensi :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={tlpRefRegister}
                        onChange={(e) =>
                          setTlpRefRegister(e.target.value.toUpperCase())
                        }
                        type="number"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Box sx={spacingTop}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate("/register")}
              sx={{ marginRight: 2 }}
            >
              {"< Kembali"}
            </Button>
            <Button variant="contained" startIcon={<EditIcon />} type="submit">
              Simpan
            </Button>
          </Box>
        </Form>
      </Paper>

      <Divider sx={dividerStyle} />
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
};

export default UbahRegister;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  mt: 2,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const contentContainer = {
  p: 3,
  pt: 1,
  mt: 2,
  backgroundColor: Colors.grey100,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};
